import type { NumberFormat } from './formatter.js';

export type NumberCellFormat = {
  type: NumberFormat;
  label: string;
  symbol: string; // New property for symbol
};

export const numberFormats: NumberCellFormat[] = [
  { type: 'number', label: 'Número', symbol: '#' },
  {
    type: 'numberWithCommas',
    label: 'Número com separador de milhares',
    symbol: '#',
  },
  { type: 'percent', label: 'Porcentagem', symbol: '%' },
  { type: 'currencyYen', label: 'Iene japonês', symbol: '¥' },
  { type: 'currencyCNY', label: 'Yuan chinês', symbol: '¥' },
  { type: 'currencyINR', label: 'Rupia indiana', symbol: '₹' },
  { type: 'currencyUSD', label: 'Dólar americano', symbol: '$' },
  { type: 'currencyEUR', label: 'Euro', symbol: '€' },
  { type: 'currencyGBP', label: 'Libra esterlina', symbol: '£' },
];
